import script from "./menu-presenter-content-tree.vue?vue&type=script&setup=true&lang=ts"
export * from "./menu-presenter-content-tree.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__